import React from 'react';
import BottomBar from '../../../components/BottomBar';
import { bodyFontSizesBOH, formatMilitaryToRegular, paginateArray, titleFontSizesBOH } from '../../../helpers/utils';
import './ShiftTask.scss';
import { Textfit } from 'react-textfit';
const getStatusClass = status => {
  switch (status) {
    case 'COMPLETE':
      return 'complete';
    default:
      return 'not-complete';
  }
};
const getStatusText = status => {
  switch (status) {
    case 'COMPLETE':
      return 'COMPLETED';
    default:
      return 'NOT COMPLETED';
  }
};
const ShiftTask = ({
  metadata,
  data,
  text
}) => {
  var _data$hits, _paginatedShiftLogs;
  const shift_logs = (data === null || data === void 0 ? void 0 : data.shift_logs) || [];
  const logo = metadata.logo;
  const accent_color = metadata.accent_color;
  const hits = (_data$hits = data === null || data === void 0 ? void 0 : data.hits) !== null && _data$hits !== void 0 ? _data$hits : 0;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const paginatedShiftLogs = paginateArray(shift_logs, 8);
  const rows = ((_paginatedShiftLogs = paginatedShiftLogs[hits % paginatedShiftLogs.length]) !== null && _paginatedShiftLogs !== void 0 ? _paginatedShiftLogs : []).map((task, i) => /*#__PURE__*/React.createElement("div", {
    className: "list-item",
    key: i
  }, (task === null || task === void 0 ? void 0 : task.time) !== -1 && /*#__PURE__*/React.createElement("div", {
    className: "item-time",
    style: {
      fontFamily: text.body_font_family,
      backgroundColor: accent_color,
      color: text.accent_color
    }
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'time' + text.body_font_family,
    mode: "single",
    min: 20,
    max: 35,
    style: {
      width: '90%',
      padding: '0px 0px 0px 10px'
    }
  }, formatMilitaryToRegular(task.time))), /*#__PURE__*/React.createElement("div", {
    className: "item-title",
    style: {
      color: text.body_color,
      fontFamily: text.body_font_family
    }
  }, task.description), /*#__PURE__*/React.createElement("div", {
    className: `item-status ${getStatusClass(task.status)}`,
    style: {
      fontFamily: text.body_font_family
    }
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'status' + text.body_font_family,
    mode: "single",
    min: 25,
    max: 35,
    style: {
      width: '90%',
      padding: '0px 10px'
    }
  }, getStatusText(task.status)))));
  return /*#__PURE__*/React.createElement("div", {
    className: "ShiftTask",
    style: {
      '--title-font-size-large': titleFontSizesBOH.large + 'px',
      '--title-font-size-medium': titleFontSizesBOH.medium + 'px',
      '--title-font-size-small': titleFontSizesBOH.small + 'px',
      '--body-font-size-large': bodyFontSizesBOH.large + 'px',
      '--body-font-size-medium': bodyFontSizesBOH.medium + 'px',
      '--body-font-size-small': bodyFontSizesBOH.small + 'px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text",
    style: {
      color: text.title_color,
      fontFamily: text.title_font_family
    }
  }, text.title), logo && /*#__PURE__*/React.createElement("img", {
    className: "logo",
    src: logo,
    alt: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "shift-logs-list-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-logs-list"
  }, rows)), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text.accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default ShiftTask;